// extracted by mini-css-extract-plugin
module.exports = {"view-report":"view-report-f62c42caf70ad038f6c4dfe8b9ae46a8"};